/****************************************************
 * Module Name:  labPricingApproval.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useRef, useState } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import LabTestProxy from "../../utility/proxy/manager/labTestProxy";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import StoneDetailModal from "../common/stoneDetailModal";
import Constants from "../../utility/constants";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import PricingApproveModal from "./pricingApprovalModal";
import { ThumbDownAlt } from "@mui/icons-material";
import CommonStoneSelection from "../common/commonStoneSelection";

import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import ReportProxy from "../../utility/proxy/manager/reportProxy";
import PDFModal from "../common/pdfModal";
import { HiPrinter } from "react-icons/hi2";
import StickerPrintModal from "../common/stickerPrintModal";
import StoneMediaModal from "../common/stoneMediaModal";
import { LoadingButton } from "@mui/lab";
import PageTitle from "../common/pageTitle";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import { VscRunAll } from "react-icons/vsc";

const LabPricingApproval = () => {
  const [listData, setListData] = useState([]);

  const [pricingLoader, setPricingLoader] = useState(false);

  const [selectedRowData, setSelectedRowData] = useState([]);

  const [selectionModel, setSelectionModel] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [successResponse, setSuccessResponse] = useState(false);
  const [type, setType] = useState("");
  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [columnNames, setColumnNames] = React.useState([]);
  const [byte, setByte] = useState();
  const [showStickerModal, setShowStickerModal] = useState(false);

  const [stoneMediaURL, setStoneMediaURL] = useState([]);
  const [showStoneMediaModal, setShowStoneMediaModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);

  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.OPERATION_LAB_PRICING
    )
  );

  //top most summary table 
  const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
  const [selectedTotalSize, setSelectedTotalSize] = useState("0");
  const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
  const [selectedavgPrice, setSelectedavgPrice] = useState("0");
  const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarVariant, setSnackbarVariant] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [extraPacket, setExtraPacket] = useState([]);
  const extraPacketRef = useRef(extraPacket);

  useEffect(() => {
    extraPacketRef.current = extraPacket;
  }, [extraPacket]);

  // Create a connection
  const ws = useRef(null);

  const startScanning = () => {

    if (!ws.current) {
      ws.current = new WebSocket(Constants.RFID_API);

      ws.current.onerror = () => {
        setShowSnackbar(true);
        setSnackbarMessage(`RFID Machine not found. Please setup your RFID Machine and try again later.`);
        setSnackbarVariant("error");
        ws.current = null;
      }
    }

    // Open WebSocket connection and start scanning
    if (!ws.current || ws.current.readyState === WebSocket.CLOSED) {
      // WebSocket doesn't exist or was closed — create new one
      ws.current = new WebSocket(Constants.RFID_API);

      ws.current.onerror = () => {
        setShowSnackbar(true);
        setSnackbarMessage(`RFID Machine not found. Please setup your RFID Machine and try again later.`);
        setSnackbarVariant("error");
        ws.current = null;
      }

      ws.current.onopen = () => {
        ws.current.send("START_SCAN");
      };
    } else if (ws.current.readyState === WebSocket.CONNECTING) {
      // Still connecting — safely attach onopen
      ws.current.onopen = () => {
        ws.current.send("START_SCAN");
      };
    } else if (ws.current.readyState === WebSocket.OPEN) {
      // Already open — send immediately
      ws.current.send("START_SCAN");
    }

    // Listen for incoming messages from WebSocket
    let lstTags = new Set();
    ws.current.onmessage = (e) => {
      let message = typeof e.data === 'string' ? e.data : String(e.data);
      if (message.includes("TAG: ")) {
        const parts = message.split("TAG: ");
        if (parts.length === 2) {
          const remaining = parts[1].trim(); // remove extra whitespace
          remaining.split(',').forEach(str => lstTags.add(str.trim())); // split and trim each item
        }

        if (listData.length > 0) {
          setTagsSelections(lstTags);
        }
      } else if (message.includes("SCAN_COMPLETED")) {
        ws.current.close();
        ws.current.onclose = () => {
          getStoneIdByTagId();
        }
      }
    };
  }

  const setTagsSelections = (tags) => {
    //tags is array or string which are tag sample ['t1','t2']
    let lStockData = listData;
    let iNewSelected = 0;
    let iUnSelectedTags = 0;
    let selectedCheckBox = [];
    let tagsFound = [];
    let tagsNotFound = [];

    for (let loopCnt = 0; loopCnt < lStockData.length; loopCnt++) {
      if (lStockData[loopCnt].tag && tags.has(lStockData[loopCnt].tag)) {
        selectedCheckBox.push(lStockData[loopCnt].stoneid);
        tagsFound.push(lStockData[loopCnt].tag);
        iNewSelected++;
      }
    }

    tagsNotFound = [...tags].filter(tag => !tagsFound.includes(tag));
    iUnSelectedTags = tags.size - iNewSelected;

    setListData(() => {
      let selectedStone = [];
      let unSelectedStone = [];
      lStockData.forEach((res) => {
        if (selectedCheckBox.includes(res.stoneid)) {
          selectedStone.push(res);
        } else {
          unSelectedStone.push(res);
        }
      });
      return [...selectedStone, ...unSelectedStone];
    });
    setSelectionModel(selectedCheckBox);
    if (tagsNotFound.length > 0) {
      setExtraPacket(prev => Array.from(new Set([...prev, ...tagsNotFound])));
    }

    return {
      NewSelectedStones: iNewSelected,
      UnusedTags: iUnSelectedTags,
    };
  };

  const getStoneIdByTagId = () => {
    if (extraPacketRef.current.length > 0) {
      StoneProxy.GetStoneIdByTagId(extraPacketRef.current, (response) => {
        if (response) {
          let resultString = Object.entries(response)
            .map(([stoneid, tag]) => `${stoneid}: ${tag}`)
            .join(', ');

          if (Object.entries(response).length < extraPacketRef.current.length) {
            const usedTags = new Set(Object.values(response));
            const extraTags = extraPacketRef.current.filter(tag => !usedTags.has(tag));

            const extraTagString = extraTags.map(tag => `STONE_ID: ${tag}`).join(', ');
            resultString = resultString + ', ' + extraTagString;
          }

          setShowSnackbar(true);
          setSnackbarMessage(`You have ${resultString} extra package on your RF Machine`);
          setSnackbarVariant("error");
          setExtraPacket([]);
          ws.current = null;
        } else {
          setShowSnackbar(true);
          setSnackbarMessage(Constants.APiFailErrorMessage);
          setSnackbarVariant("error");
          ws.current = null;
          setExtraPacket([]);
        }
      })
    }
  }

  useEffect(() => {
    PageTitle("OPERATION_LAB_PRICINGAPPROVAL");
    handleSearch();
  }, []);

  const loadTotalData = (data) => {
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size

    data.forEach((iData) => {
      let pricePerCarat = iData.price
      totalSize += iData.size;
      totalPrice += (iData.size * pricePerCarat);
      total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

    });
    setNoOfSelectedStones(data.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  };

  useEffect(() => {
    if (selectionModel.length <= 0) {
      loadTotalData(listData);
      return;
    }
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size
    listData.forEach((iData) => {
      if (selectionModel.includes(iData.stoneid)) {
        let pricePerCarat = iData.price
        totalSize += iData.size;
        totalPrice += (iData.size * pricePerCarat);
        total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
      }
    });
    setNoOfSelectedStones(selectionModel.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );

  }, [selectionModel]);

  const handleSearch = () => {
    setPricingLoader(true);
    LabTestProxy.GetAllPricingApprovalStones((response) => {
      if (response) {
        let defaultrows = [];
        response.map((item) => {
          let option = {
            stoneid: item.stoneid,
            user: Constants.loggedInUser.id,
            remark: "",
          };
          defaultrows.push(option);
          return true;
        });

        const uniqueFilterValues = {
          labshape: Utility.getDistinctOptions(response, 'labshape'),
          distinctStatus: Utility.getDistinctOptions(response, 'status'),
        }

        prepareColumns(uniqueFilterValues);
        setListData(response);
        loadTotalData(response);
        setSelectedRowData(defaultrows);
        setPricingLoader(false);
        type === "APPROVE" ? setLoading(false) : setRejectLoading(false);
      } else {
        setErrorSnackbar(true)
        setPricingLoader(false);
      }
    });
  };

  const handleValidation = (data) => {
    //TODO do validation if needed here
    return true;
  };

  const sendForPriceApproval = (data) => {
    type === "APPROVE" ? setLoading(true) : setRejectLoading(true);
    setShowModal(false);
    LabTestProxy.SendForPriceApproval(data, (responseData) => {
      if (responseData) {
        handleSearch();
        setSuccessResponse(true);
      } else {
        setErrorSnackbar(true);
        type === "APPROVE" ? setLoading(false) : setRejectLoading(false);
      }
    });
  };

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const handleClose = () => {
    setShowStoneDetailModal(false);
  };

  const handleSelection = (data) => {
    const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, listData, selectionModel);

    setListData(tempStockData);
    setSelectionModel(tempSelectionModel);
  }

  const prepareColumns = (uniqueFilterValues) => {
    let columnNames = [];

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        if (columnData.field === "status") {
          columnData.type = "singleSelect";
          columnData.valueOptions = uniqueFilterValues.distinctStatus;
          columnData.filterOperators = Utility.combinedFilters();
        }
        columnNames.push(columnData);
        if (columnData.field === "stoneid") {
          columnNames.push({
            field: "suratid",
            headerName: "SURATID",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
          })
        }
        if (columnData.field === "shape") {
          columnNames.push({
            field: "labshape",
            headerName: "LAB SHAPE",
            headerAlign: "center",
            align: "center",
            width: 90,
            renderCell: renderCellExpand,
            type: "singleSelect",
            valueOptions: uniqueFilterValues.labshape,
          })
        }
        if (columnData.field === "olddiscount") {
          columnNames.push({
            field: "discount",
            headerName: "DIS",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 80,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount),
            cellClassName: (params) => {
              return (params.row.colortype === "WHITE") ? 'lavenderCell' : null;
            }
          })
        }
        else if (columnData.field === "oldprice") {
          columnNames.push({
            field: "price",
            headerName: "PPC",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 80,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price),
            cellClassName: (params) => {
              return (params.row.colortype === "FANCY") ? 'lavenderCell' : null;
            }
          })
        }
        else if (columnData.field === "oldtotal") {
          columnNames.push({
            field: "total",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "center",
            width: 90,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total),
            cellClassName: 'lavenderCell',
          })
        }
      }
    });
    setColumnNames(columnNames);
  }



  const columnsData = {
    "item-1": {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
    },
    "item-2": {
      field: "username",
      headerName: "USERNAME",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      align: "center",
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline", color: "black" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
      editable: true,
    },
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "c6161d51-13c0-479e-abe8-2a14b2d8b914": {
      field: "resultdate",
      headerName: "RESULT DATE",
      headerAlign: "center",
      width: 100,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      align: "center",
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.value),
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 40,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 80,
      renderCell: renderCellExpand,
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "rapnetprice",
      headerName: "RAP",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "right",
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "olddiscount",
      headerName: "MF DIS",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 50,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.olddiscount),
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "oldprice",
      headerName: "MF PPC",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.oldprice),
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "oldtotal",
      headerName: "MF TOTAL",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.oldtotal)
    },
    "6defca68-d5d9-4c30-ae83-938a01f45a07": {
      field: "colortype",
      headerName: "COL TYPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
      width: 65,
      renderCell: renderCellExpand,
    },
    "d4992de9-92ab-4f9e-ba12-6c746e935611": {
      field: "colordescriptions",
      headerName: "COL DESCRIP",
      headerAlign: "center",
      align: "center",
      width: 110,
      renderCell: renderCellExpand,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 50,
      renderCell: renderCellExpand,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 40,
      renderCell: renderCellExpand,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 40,
      renderCell: renderCellExpand,
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 60,
      renderCell: renderCellExpand,
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
      field: "width",
      headerName: "WIDTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      type: "number",
      valueFormatter: (params) => params.value,
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
      renderCell: renderCellExpand,
    },
    "19ce7030-402c-495c-84ac-a29093bdb0ac": {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "f97a0118-3891-4f77-abf7-8636c26d594c": {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
      field: "height",
      headerName: "HEIGHT",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 70,
      renderCell: renderCellExpand,
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "e7210f4a-6e0a-4591-8428-e6845004ed04": {
      field: "crownheight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
      field: "culetsize",
      headerName: "CULET SZ",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "e3f77521-2c57-46bc-a02b-3c884685d2be": {
      field: "culetcondition",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "e83c2978-9088-49f0-9dc1-bcced73025fd": {
      field: "gridlemin",
      headerName: "GIRDLEMIN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
      field: "intensitylongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "06d2a589-0d42-4dde-8724-acf2448c839a": {
      field: "laserinscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    "dd934505-1865-48cb-878f-f5d3c18af2d5": {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "e9028170-e978-4978-a2c9-1889c1821495": {
      field: "gridlecondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
      field: "gridlepercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
      field: "pavilionangle",
      headerName: "PV.ANGLE",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cf694b75-ba5d-4a73-8fcf-e7566974c4b6": {
      field: "media",
      headerName: "MEDIA",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: (params) => (
        <Tooltip title={"Stone Media"} sx={{ cursor: "pointer" }}>
          <VideoLibraryTwoToneIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setStoneMediaURL(params.row.stonemediaurl);
              setShowStoneMediaModal(true);
            }} />
        </Tooltip>
      ),
    },
  };

  const columns = columnNames;

  // Packet Print
  const printPacket = () => {
    let data = listData.filter(item => selectionModel.includes(item.stoneid));
    ReportProxy.GeneratePacketPrintPDF(data, response => {
      if (response) {
        setByte(response.fileBytes);
        openModal()
      }
    })
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>

      <TabMenuSnackbar
        show={showSnackbar}
        message={snackbarMessage}
        variant={snackbarVariant}
        autoHide={Constants.SnackBarCloseTimer}
        title={snackbarVariant === "success" ? "Success" : snackbarVariant === "error" ? "Error" : "Warning"}
        handleClose={() => setShowSnackbar(false)}
      />

      {/*need to send pdf in byte string to modal */}
      <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={byte} pdfName={"packetPrint"} />

      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneId}
          handleClose={handleClose}
        />
      ) : null}

      {showStickerModal ? (
        <StickerPrintModal
          show={showStickerModal}
          stoneIds={selectionModel}
          handleClose={() => setShowStickerModal(false)}
        />
      ) : null}

      {showStoneMediaModal ? (
        <>
          <StoneMediaModal
            show={showStoneMediaModal}
            stoneMediaURL={stoneMediaURL}
            handleClose={() => setShowStoneMediaModal(false)}
          />
        </>
      ) : null}

      {successResponse ? (
        <TabMenuSnackbar
          show={successResponse}
          message={
            type === "APPROVE" ? "Pricing Approved" : "Pricing Rejected"
          }
          variant={"success"}
          autoHide={true}
          title={"Success"}
          handleClose={() => setSuccessResponse(false)}
        />
      ) : null}
      <TabMenuSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Failed"}
        handleClose={() => setErrorSnackbar(false)}
      />

      <Box m={1} sx={{ display: "flex", }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            m: "0px 15px 0 30px",
            color: "black",
            paddingTop: "8px",
            paddingLeft: "8px",
            fontWeight: 'normal',
            fontSize: Constants.defaultTableFontSize
          }}

        ><p>
            <span>No of Stones: </span> <b>{noOfSelectedStones}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Total Weight: </span> <b>{selectedTotalSize}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Total Price: </span> <b>{selectedtotalPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Avg Price: </span> <b>{selectedavgPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Avg Discount: </span> <b>{selectedAvgDiscount}</b></p>

        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          width: "100%",
          position: "relative",
          "& .MuiTablePagination-selectLabel": {
            marginTop: "15px",
          },
          "& .MuiTablePagination-displayedRows": {
            marginTop: "15px",
          },
          "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
            fontWeight: Constants.defaultFontWeight,
          },
          "& .css-cc8tf1": {
            fontWeight: Constants.defaultFontWeight,
          },
          "& .lavenderCell": {
            color: "#080808",
            backgroundColor: "#D8BFD8",
          },
          height: "70vh",
        }}
      >
        <DataGridPro
          disableRowSelectionOnClick={true}
          sx={{
            '& .MuiDataGrid-columnHeader': {
              color: '#fff',
              backgroundColor: 'grey',
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
              py: "4px",
            },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
              py: "12px",
            },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
              py: "18px",
            },
            "& .MuiDataGrid-toolbarContainer": {
              padding: "4px 4px 0 90px !important"
            },
            fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
          }}
          density="compact"
          loading={pricingLoader}
          slots={{ toolbar: GridToolbar }}
          rows={listData}
          columns={columns}
          getRowId={(row) => row.stoneid}
          checkboxSelection={true}
          onRowSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          rowSelectionModel={selectionModel}
          initialState={{
            columns: {
              columnVisibilityModel: {
                // Hide columns id, the other columns will remain visible
                id: false,
                lab: false,
                locationid: false,
                cutpolsym: false,
                culetsize: false,
                crownheight: false,
                crownangle: false,
                culetcondition: false,
                gridlemin: false,
                intensitylongtitle: false,
                laserinscription: false,
                country: false,
                quality: false,
                status: false,
                location: false,
                stonelabdetailstatus: false,
                open: false,
                gridlepercent: false,
                gridlecondition: false,
                pavilionangle: false,
                paviliondepth: false,
                white: false,
                nextstate: false,
                remark: false,
                note: false,
                height: false,
                username: false,
                oldtotal: false,
                olddiscount: false,
                oldprice: false,
                suratid: false
              },
            },
            sorting: {
              sortModel: [{ field: "stoneid", sort: "asc" }],
            },
            pagination: {
              paginationModel: Constants.pageSize,
            },
          }}
          pageSizeOptions={Constants.pageSizeOptions}
          pagination
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
        <Box sx={{
          position: "absolute",
          left: "0.4rem",
          top: "1px",
          display: "flex"
        }}>
          <CommonStoneSelection title={"Enter multiple Stone Ids"} handleSelection={handleSelection} buttonDisabled={listData.length === 0} />
          <Tooltip title={"Start Scan"}>
            <IconButton
              color={"success"}
              onClick={() => startScanning()}
              disabled={listData.length === 0}
            >
              {<VscRunAll />}
            </IconButton>
          </Tooltip>
        </Box>
        <Box
          style={{
            position: "absolute",
            top: 6,
            left: "490px",
            display: "flex",
          }}
        >
          {Utility.isAddAllowed(local_Permission) ? (
            <Tooltip title={"Print Packet"}>
              <Button
                variant="outlined"
                size="small"
                component="label"
                sx={{ ml: "10px" }}
                color="secondary"
                startIcon={<HiPrinter size={14} />}
                disabled={selectionModel.length === 0}
                onClick={printPacket}
              >
                Packet
              </Button>
            </Tooltip>
          ) : null}

          {Utility.isAddAllowed(local_Permission) ? (
            <Tooltip title={"Print Sticker"}>
              <Button
                variant="outlined"
                size="small"
                component="label"
                sx={{ ml: "10px" }}
                color="secondary"
                startIcon={<HiPrinter size={14} />}
                onClick={() => setShowStickerModal(true)}
              >
                Sticker
              </Button>
            </Tooltip>
          ) : null}
        </Box>
        <Box
          style={{
            position: "absolute",
            top: 5,
            right: "270px",
            display: "flex",
            flexWrap: "nowrap",
          }}
        >
          {pricingLoader ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                onClick={() => handleSearch()}
                color="primary"
                fontSize="medium"
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}
          {Utility.isUpdateAllowed(local_Permission) ? (
            <Tooltip title="Approve Stones">
              <LoadingButton
                component="label"
                variant="outlined"
                size="small"
                sx={{ ml: "5px" }}
                startIcon={<ThumbUpAltIcon size="large" />}
                disabled={selectionModel.length < 1 || rejectLoading}
                onClick={() => {
                  setShowModal(true);
                  setType("APPROVE");
                }}
                loading={loading}
                loadingPosition="start"
                type="submit"
              >
                Approve
              </LoadingButton>
            </Tooltip>
          ) : null}
          {showModal && (
            <PricingApproveModal
              show={showModal}
              setShow={setShowModal}
              handleValidation={handleValidation}
              handleSave={sendForPriceApproval}
              stoneId={selectionModel}
              selectedFilledData={selectedRowData}
              type={type}
            />
          )}
          {Utility.isUpdateAllowed(local_Permission) ? (
            <Tooltip title="Reject Stones">
              <LoadingButton
                component="label"
                variant="outlined"
                size="small"
                color="error"
                sx={{ ml: "5px" }}
                startIcon={<ThumbDownAlt size="large" />}
                disabled={selectionModel.length < 1 || loading}
                onClick={() => {
                  setShowModal(true);
                  setType("REJECT");
                }}
                loading={rejectLoading}
                loadingPosition="start"
                type="submit"
              >
                Reject
              </LoadingButton>
            </Tooltip>
          ) : null}
        </Box>
      </Box>
    </div>
  );
};

export default LabPricingApproval;
